import orderBy  from 'lodash/orderBy';
import * as React from 'react';
import { SeatStyle, SeatStyleCulture } from '../../classes/seat';
import LegendContent from './legend-content';




interface ILegendProps {
    seatStyles: Array<SeatStyle>;
    seatStyleCultures: Array<SeatStyleCulture>;
    legendTitle: string;
    legendModalText: string;
    legendTitleAltText: string;
    selectedSeats: boolean;
    legendFlyOut: boolean;
    updateLegendFlyout: (updateFlyout: boolean) => void;
    isMobile: boolean;
}

interface ILegendState {
    firstTimeHidden: boolean; //used to keep track so we only close the legend once so if users want to use the legend on mobile, they can open it again
}

class LegendModal extends React.PureComponent<ILegendProps, ILegendState>{

    constructor(props) {
        super(props);
        this.state = { firstTimeHidden: false };
    }
    componentWillReceiveProps(nextProps: ILegendProps) {

        if (!this.state.firstTimeHidden && nextProps.isMobile && nextProps.selectedSeats) {
            if (this.props.legendFlyOut) {
                nextProps.updateLegendFlyout(false);
            }

            this.setState({ firstTimeHidden: true });
        }
    }

    render() {
        const useTag = '<use xlink:href="#icon-close" />';
        let outsideCloseClick = this.outsideCloseClick.bind(this);

        const culturesWithDisplayName = this.props.seatStyleCultures.filter(culture => culture.displayName != null);

        const visibleStyles = orderBy(this.props.seatStyles.filter(style => { return culturesWithDisplayName.some(culture => culture.seatStyleId === style.id) }),
            (style) => {
                return culturesWithDisplayName.filter(cultur => cultur.seatStyleId == style.id)[0].legendOrder;
            });

        let legendFilters =
            orderBy(visibleStyles.filter(style => culturesWithDisplayName.filter(cultur => cultur.seatStyleId == style.id)[0].showOnCollapsedLegend),
                (style) => {
                    return culturesWithDisplayName.filter(cultur => cultur.seatStyleId == style.id)[0].legendOrder;
                }
            ).map(style => {
                return <div key={style.id} className="legend-default-modal-icon" style={{ backgroundColor: style.svgDefaultFill }}></div>;
            });

        if (legendFilters.length > 3) {
            legendFilters = legendFilters.filter((value, index) => index < 3);
        }

        return (
            <div className={"legend-container-modal" + (this.props.legendFlyOut ? " open" : "")}>
                {
                    !this.props.legendFlyOut ?
                        <div className="legend-trigger-modal" onClick={(evt) => { this.props.updateLegendFlyout(true) }}>
                            <div className="legend-default-modal-dots">
                                {
                                    legendFilters
                                }
                            </div>

                            <p>{this.props.legendTitle}</p>

                        </div>

                        : null
                }
                {
                    this.props.legendFlyOut ?

                        <div className="legend-modal" onClick={outsideCloseClick}>
                            <div className="legend-modal-inner">
                                <div className="legend-modal-header">
                                    <h2>{this.props.legendTitle}</h2>
                                    <svg className="legend-modal-close-icon" dangerouslySetInnerHTML={{ __html: useTag }} onClick={(evt) => { this.props.updateLegendFlyout(false) }} />

                                </div>

                                <LegendContent {...this.props} renderModal={true} />

                            </div>
                        </div>
                        : null
                }


            </div>
        );
    }

    outsideCloseClick() {
        if (!(event.target as any).closest('.legend-modal-inner')) {
            this.props.updateLegendFlyout(false);
        }
    }
}

export default LegendModal;